import {
    DesvincularUsuarioHelpdeskGerenciaServices,
    ListarEquipesGerenciaServices,
    ListarUsuariosDesvinculadosServices,
    ListarUsuariosVinculadosServices,
    VincularUsuarioHelpdeskGerenciaServices,
} from "../../../Services/HelpDesk/Equipes/EquipesGerenciaService";
import { IEquipeGerenciaCadastro } from "../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import { Controller } from "../../Controller";

export async function ListarUsuariosVinculadosController(
    IDEquipeHelpDesk: number
) {
    return Controller(ListarUsuariosVinculadosServices(IDEquipeHelpDesk));
}

export async function ListarUsuariosDesvinculadosController(
    IDEquipeHelpDesk: number
) {
    return Controller(ListarUsuariosDesvinculadosServices(IDEquipeHelpDesk));
}

export async function VincularUsuarioHelpdeskGerenciaController(
    requestBody: IEquipeGerenciaCadastro
) {
    return Controller(VincularUsuarioHelpdeskGerenciaServices(requestBody));
}

export async function DesvincularUsuarioHelpdeskGerenciaController(
    ID_EQUIPE_GERENCIA: number
) {
    return Controller(
        DesvincularUsuarioHelpdeskGerenciaServices(ID_EQUIPE_GERENCIA)
    );
}

export async function ListarEquipesGerenciaController() {
    return Controller(ListarEquipesGerenciaServices());
}
